module.exports = __webpack_public_path__ + "static/media/dark-minus.7d2aa3dc.svg";